import { inject, Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateParser } from '@ngx-translate/core';

@Injectable()
export class FallbackMissingTranslationHandler implements MissingTranslationHandler {
  #parser = inject(TranslateParser);

  handle(params: MissingTranslationHandlerParams) {
    if (params.interpolateParams) {
      return this.#parser.interpolate(params.key, params.interpolateParams);
    }

    return params.key;
  }
}
